export interface OpcionesLecturaCompartida {
  ttlMs?: number;
  forzar?: boolean;
}

interface EntradaLectura {
  promesa: Promise<unknown>;
  vence: number;
}

const memoria = new WeakMap<object, Map<string, EntradaLectura>>();

export function leerCompartido<T>(
  http: object,
  clave: string,
  cargar: () => Promise<T>,
  opciones: OpcionesLecturaCompartida = {},
): Promise<T> {
  let porCliente = memoria.get(http);
  if (!porCliente) {
    porCliente = new Map();
    memoria.set(http, porCliente);
  }

  const entrada = porCliente.get(clave);
  if (entrada && !opciones.forzar && (entrada.vence === Number.POSITIVE_INFINITY || Date.now() < entrada.vence)) {
    return entrada.promesa.then((valor) => structuredClone(valor)) as Promise<T>;
  }

  const promesa = cargar();
  porCliente.set(clave, { promesa, vence: Number.POSITIVE_INFINITY });

  promesa.then(
    () => {
      // Una lectura forzada (u otra llamada) puede haber reemplazado esta entrada mientras
      // `cargar()` seguía en vuelo: si ya no es la vigente, no la resucites con datos viejos.
      if (porCliente.get(clave)?.promesa !== promesa) {
        return;
      }
      const ttlMs = opciones.ttlMs ?? 0;
      if (ttlMs > 0) {
        porCliente.set(clave, { promesa, vence: Date.now() + ttlMs });
      } else {
        porCliente.delete(clave);
      }
    },
    () => {
      if (porCliente.get(clave)?.promesa === promesa) {
        porCliente.delete(clave);
      }
    },
  );

  return promesa.then((valor) => structuredClone(valor)) as Promise<T>;
}

export function invalidarLecturasCompartidas(http: object): void {
  memoria.delete(http);
}
